export default __webpack_public_path__ + "static/media/investorSteveJobs.07c150be.mp3";